import { render, staticRenderFns } from "./EditToolbar.vue?vue&type=template&id=600d2fbc&"
import script from "./EditToolbar.vue?vue&type=script&lang=ts&"
export * from "./EditToolbar.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports